import { render, staticRenderFns } from "./VerificarPeloCPF.vue?vue&type=template&id=20b7f63d&scoped=true&"
import script from "./VerificarPeloCPF.vue?vue&type=script&lang=js&"
export * from "./VerificarPeloCPF.vue?vue&type=script&lang=js&"
import style0 from "./VerificarPeloCPF.vue?vue&type=style&index=0&id=20b7f63d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20b7f63d",
  null
  
)

export default component.exports